module.exports = __webpack_public_path__ + "img/free-to-apply.3018647d.png";